import { getTwilioAiCallsDataSource } from "./twilioAiCalls.requests";
import { twilioAiCallsStore } from "./twilioAiCalls.store";

export class TwilioAiCallsQuery {
  store = twilioAiCallsStore;
  twilioAiCalls$ = getTwilioAiCallsDataSource.data$();
}

export const twilioAiCallsQuery = new TwilioAiCallsQuery();
